module.exports = __webpack_public_path__ + "img/octopus-2.32a5b085.png";